import React from "react";
import { Marked } from "marked";
import { markedHighlight } from "marked-highlight";
import hljs from "highlight.js/lib/common";
import "highlight.js/styles/github.css";
import "./markdown.css";

// Shared Marked instance with syntax highlighting. Used by every widget
// that renders user-authored markdown so the visual treatment is the
// same everywhere (thread widget, message widget, …).
const playgroundMarked = new Marked(
  markedHighlight({
    langPrefix: "hljs language-",
    highlight(code, lang) {
      const language = lang && hljs.getLanguage(lang) ? lang : "plaintext";
      try {
        return hljs.highlight(code, { language, ignoreIllegals: true }).value;
      } catch (e) {
        return code;
      }
    }
  })
);

export function MarkdownBody({ text, className }) {
  if ( typeof text !== "string" ) {
    return null;
  }
  const cls = className ? `playground-markdown ${className}` : "playground-markdown";
  const html = { __html: playgroundMarked.parse(text) };
  return <div className={cls} dangerouslySetInnerHTML={html} />;
}

export default MarkdownBody;
